import { useObserverStore } from "../../stores/observerStore";

export function StatsBar(): React.JSX.Element {
	const connected = useObserverStore((s) => s.connected);
	const agentCount = useObserverStore((s) => s.agents.size);
	const travelCount = useObserverStore((s) => s.activeTravels.length);
	const viewMode = useObserverStore((s) => s.viewMode);
	const focusedSystem = useObserverStore((s) => s.focusedSystem);
	const exitSystemView = useObserverStore((s) => s.exitSystemView);

	return (
		<div
			style={{
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				display: "flex",
				alignItems: "center",
				gap: "1.5rem",
				padding: "0.6rem 1rem",
				background: "rgba(10, 10, 15, 0.85)",
				backdropFilter: "blur(8px)",
				borderBottom: "1px solid rgba(26, 26, 46, 0.8)",
				zIndex: 20,
				fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
				fontSize: "0.8rem",
			}}
		>
			<span
				style={{
					color: "#bb9af7",
					fontWeight: 700,
					fontSize: "0.9rem",
					letterSpacing: "0.05em",
				}}
			>
				VOIDEX ARENA
			</span>

			<span style={{ color: "#565680", fontSize: "0.75rem" }}>LIVE MAP</span>

			{viewMode === "system" && focusedSystem && (
				<button
					type="button"
					onClick={exitSystemView}
					style={{
						background: "rgba(122, 162, 247, 0.15)",
						border: "1px solid rgba(122, 162, 247, 0.3)",
						borderRadius: "4px",
						color: "#7aa2f7",
						padding: "0.2rem 0.6rem",
						cursor: "pointer",
						fontSize: "0.7rem",
						fontFamily: "inherit",
					}}
				>
					← Galaxy
				</button>
			)}

			<div style={{ marginLeft: "auto", display: "flex", gap: "1.2rem", alignItems: "center" }}>
				<span style={{ color: "#c8c8d0" }}>
					{agentCount} agent{agentCount !== 1 ? "s" : ""}
				</span>

				<span style={{ color: "#c8c8d0" }}>{travelCount} traveling</span>

				<span
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.4rem",
						color: connected ? "#73daca" : "#f7768e",
						fontSize: "0.7rem",
					}}
				>
					<span
						style={{
							width: "6px",
							height: "6px",
							borderRadius: "50%",
							background: connected ? "#73daca" : "#f7768e",
							display: "inline-block",
						}}
					/>
					{connected ? "LIVE" : "OFFLINE"}
				</span>
			</div>
		</div>
	);
}
